import React, { useState, useEffect } from 'react';
import api from '../../utils/axios';

// Preview de los primeros 10 movimientos de una alerta
const AlertMovimientosPreview = ({ alertId, movimientosIds }) => {
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMovimientos = async () => {
      try {
        const res = await api.post('/movimientos/by-ids', movimientosIds.slice(0, 10));
        setMovimientos(res.data || []);
      } catch (error) {
        console.error('Error loading movimientos preview:', error);
      } finally {
        setLoading(false);
      }
    };
    loadMovimientos();
  }, [movimientosIds]);

  if (loading) {
    return <div className="text-xs text-slate-400 animate-pulse">Cargando movimientos...</div>;
  }

  if (movimientos.length === 0) {
    return <div className="text-xs text-slate-400">No se encontraron movimientos</div>;
  }

  const formatMoney = (amount) => {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(amount || 0);
  };

  return (
    <div className="space-y-2">
      {movimientos.map((mov, idx) => (
        <div key={mov.id_waya || idx} className="flex items-center justify-between text-xs p-2 bg-slate-50 rounded border">
          <div className="flex-1 min-w-0">
            <div className="font-mono text-slate-600 truncate">
              {mov.cbu_cvu_origen?.slice(0, 8)}... → {mov.cbu_cvu_destino?.slice(0, 8)}...
            </div>
            <div className="text-slate-400">{mov.fecha ? new Date(mov.fecha).toLocaleDateString() : 'N/A'}</div>
          </div>
          <div className="text-right font-semibold text-green-700">{formatMoney(mov.monto)}</div>
        </div>
      ))}
      {movimientosIds.length > 10 && (
        <p className="text-xs text-slate-400 text-center">+ {movimientosIds.length - 10} más...</p>
      )}
    </div>
  );
};

export default AlertMovimientosPreview;
